<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-header classes="no-border">
        <h3>
          <ng-container *ngIf="editMode; else noeditmodeheader">
            {{'lang.globals.editMedium' | translate}}
          </ng-container>
          <ng-template #noeditmodeheader>
            {{'nav.contentEditor.createContent' | translate}}
          </ng-template>
        </h3>
        <small>
          {{'lang.contentEditor.template' | translate}}
          :&nbsp;<b>{{template?.name}}</b>&nbsp;&frasl;&nbsp;{{'lang.globals.medium' | translate}}
          :&nbsp;<b>{{Name?.value}}</b>
        </small>
      </div>
      <div card-header-more>
        <div class="d-flex align-items-center" *ngPermissions="permissionService.Permission.medium_upload">
          <button *ngIf="showPreviewButton" (click)="preview()" class="btn btn-hover-primary mr-1">
            <sb-icon icon="motiveExplorer"></sb-icon>&nbsp;{{"lang.globals.preview" | translate}}
          </button>
        </div>
      </div>
      <div card-fit>
        <sb-wizard #wizard [hideTabs]="false">
          <sb-wizard-tab #tab1 titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}"
                         icon="basicSettings">
            <form [formGroup]="form" class="wizard__forms px-5 pb-5">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="my-4">{{'lang.globals.details' | translate}}</h3>
                  <div class="row">
                    <div class="col-md-12 col-lg-6">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                        <input type="text" id="Title" class="form-control"
                               formControlName="Name">
                        <span class="form-text text-muted">{{'lang.globals.nameDescription' | translate}}</span>
                        <div *ngIf="Name.touched && Name.errors?.required"
                             class="alert alert-danger">
                          {{'lang.globals.nameWarning' | translate}}</div>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <div class="form-group d-grid">
                        <label class="form-label" for="Company">{{'lang.globals.company' | translate}}</label>
                        <button (click)="selectCompany()" type="button" id="Company"
                                class="btn btn-secondary  text-center">
                          <sb-icon class="mr-1" icon="company"></sb-icon>
                          {{customer ? customer?.name : 'Default'}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr class="border-dashed d-md-none">
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <h3 class="my-4">{{'lang.globals.resolution' | translate}}
                    <sb-button (click)="selectMarker()" classes="btn-hover-primary mr-1">
                      <sb-icon icon="marker"></sb-icon>
                    </sb-button>
                  </h3>
                  <div class="row">
                    <div class="col-md-12 col-lg-6">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Width">{{'lang.globals.width' | translate}}<span class="red">*</span></label>
                        <input type="number" id="Width" class="form-control"
                               formControlName="Width">
                        <span class="form-text text-muted">{{'lang.globals.widthDescription' | translate}}</span>
                        <div *ngIf="Width.touched && Width.errors?.required"
                             class="alert alert-danger">
                          {{'lang.globals.widthWarning' | translate}}</div>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Height">{{'lang.globals.height' | translate}}<span class="red">*</span></label>
                        <input type="number" id="Height" class="form-control"
                               formControlName="Height">
                        <span class="form-text text-muted">{{'lang.globals.heightDescription' | translate}}</span>
                        <div *ngIf="Height.touched && Height.errors?.required"
                             class="alert alert-danger">
                          {{'lang.globals.heightWarning' | translate}}</div>
                      </div>
                    </div>
                  </div>
                  <hr class="border-dashed d-md-none">
                </div>
              </div>
              <div class="wizard__footerActions">
                <button (click)="cancel()" type="button" class="btn btn-default btn-lg btn-wide">
                  {{'lang.globals.cancel' | translate}}
                </button>
                <button (click)="showEditor = true; nextStep(wizard, tab2); reloadEditor()" type="button"
                           [disabled]="!form.valid" class="btn btn-success btn-wide btn-lg">
                  {{'lang.globals.next' | translate}}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
          <sb-wizard-tab #tab2 titleText="{{ 'lang.globals.edit' | translate }}" icon="edit" [active]="false">
            <form [formGroup]="form" class="wizard__forms pb-5">
              <div class="row">
                <div class="col-md-12">
                  <!-- <h3 class="my-4">{{'lang.globals.edit' | translate}}</h3> -->
                  <div class="row">
                    <div class="col-md-12">
                      <ng-container *ngIf="loadEditor">
                        <email-editor [projectId]="projectId" [displayMode]="displayMode"
                                      [locale]="locale" [dockSide]="dockSide" [theme]="theme"
                                      [preview]="editorPreview" [stockImages]="stockImages"
                                      (loaded)="editorLoaded($event)" [user]="user"
                                      [signature]="signature">
                        </email-editor>
                      </ng-container>
                    </div>
                  </div>
                  <hr class="border-dashed d-md-none">
                </div>
              </div>
              <div class="wizard__footerActions px-5">
                <button type="button"
                  (click)="showEditor = false; showPreviewButton = false; nextStep(wizard, tab1); reloadEditor()"
                  class="btn btn-default btn-lg btn-wide">
                  {{'lang.globals.back' | translate}}
                </button>
                <button (click)="submit()" type="button" [disabled]="!form.valid || loading"
                           class="btn btn-success btn-wide btn-lg">
                  {{'lang.globals.submit' | translate}}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
